import User from '@/util/models/User'

const available_roles = [
  'sys_admin','keuangan','administrasi','quran','pengawas_ujian','pewawancara','masterdata'
];

export default (all = false) => {
  var _  = require('lodash');  
    
  let roles  = all? available_roles : User.roles();   
  let result = [];
  roles.forEach(item => {
    if(_.includes(available_roles, item)){      
      let menu = require('./'+item);      
      result = [
        ...result,
        ...menu.default
      ];
    }
  });

  
  result = _.uniqWith(result, _.isEqual);
  
  return result;
}
